import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type Inputs = "operacion" | "periodo" | "metaChater";
export type Buttons = "ejecutar";

export const hiddenIfDescargar = formValue =>
  formValue.operacion === "DESCARGAR";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "operacion",
      label: "* Operación",
      bts: {
        mCol: 3
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Calcular comisiones",
        data: [{ value: "DESCARGAR", label: "Descargar reporte" }]
      }
    },
    {
      name: "periodo",
      label: "* Proyecto semestral",
      bts: {
        mCol: 3
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione un periodo"
      }
    },
    {
      name: "metaChater",
      label: "* Meta Chater",
      bts: {
        mCol: 3
      },
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        hidden: hiddenIfDescargar
      }
    }
  ],
  buttons: [
    {
      name: "ejecutar",
      label: "Aceptar",
      isSubmit: true,
      component: IButtonBuilder,
      bts: {
        mCol: 3
      }
    }
  ],
  validations: {
    periodo: {
      required: {
        message: () => "Campo obligatorio"
      }
    },
    metaChater: {
      required: {
        validator: (value, formValue) => !formValue.operacion && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["operacion", "periodo", "metaChater", "ejecutar"]]
};
